import { render, staticRenderFns } from "./hair-types-porosity.vue?vue&type=template&id=17c6ec5f&"
import script from "./hair-types-porosity.vue?vue&type=script&lang=js&"
export * from "./hair-types-porosity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports